import React, { useState, useEffect } from 'react';
import './LaunchScreen.css';
import CloudBackground from '../assets/images/Cloud Background.webp';

interface LaunchScreenProps {
  onComplete: () => void;
  /** Total time before the screen unmounts, in ms. */
  duration?: number;
}

const LaunchScreen: React.FC<LaunchScreenProps> = ({ onComplete, duration = 1300 }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => setIsExiting(true), Math.max(duration - 500, 0));
    const completeTimer = setTimeout(onComplete, duration);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [duration, onComplete]);

  return (
    // aria-hidden + role="presentation": this is a brand transition, not content.
    // The wordmark is a <div>, not an <h1> — the page's real h1 lives underneath
    // it and must stay the only one on the document.
    <div
      className={`launch-screen ${isExiting ? 'launch-screen-exit' : ''}`}
      aria-hidden="true"
      role="presentation"
    >
      <img src={CloudBackground} alt="" className="launch-background" />
      <div className="launch-content">
        <div className="holy-glow"></div>
        <div className="launch-title">uncling</div>
      </div>
    </div>
  );
};

export default LaunchScreen;
